import axios from 'axios';

const ROOT_URL = "https://todis.transport-community.org/api/";
//const ROOT_URL = "http://localhost:8080/api/";

class UserService {

    async changeAllowNotifications(id, allowNotifications) {
        try {
            const response = await axios.post(ROOT_URL + `user/update/allowNotifications`, { id, allowNotifications });
            return response.data;
        } catch (error) {
            throw new Error('Failed to change the user');
        }
    }

    async getAllUsernames() {
        try {
            const response = await axios.get(ROOT_URL + `user/allUsernames`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to load the usernames information');
        }
    }

    async getAllUsers(){
        try {
            const response = await axios.get(ROOT_URL + `user/users`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to load the users information');
        }
    }

    async getAllRoles(){
        try {
            const response = await axios.get(ROOT_URL + `role/roles/summary`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to load the roles information');
        }
    }
    
    async getAllOrgs(){
        try {
            const response = await axios.get(ROOT_URL + `organization/organizations/summary`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to load the organizations information');
        }
    }

    async getAllCoordinator(){
        try {
            const response = await axios.get(ROOT_URL + `user/allCoordinators`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to load the coordinators information');
        }
    }
}

export default UserService;
